import { State } from "@features/base/types";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getMerchantOrdersApi,
  MerchantOrder,
  MerchantOrderForm,
  MerchantOrderResponse,
} from "./api";

type MerchantOrderState = State<{
  orders: MerchantOrder[] | null;
  page: number;
  count: number;
}>;

export const getMerchantOrders = createAsyncThunk<
  MerchantOrderResponse,
  { userId: string; data?: MerchantOrderForm }
>("orders/getOrders", async ({ userId, data }, { rejectWithValue }) => {
  try {
    return await getMerchantOrdersApi(userId, data);
  } catch (error) {
    return rejectWithValue(error);
  }
});

const initialState: MerchantOrderState = {
  orders: null,
  loading: false,
  error: null,
  page: 1,
  count: 0,
};

const merchantOrdersSlice = createSlice({
  name: "orders",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMerchantOrders.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getMerchantOrders.fulfilled, (state, action) => {
        state.loading = false;
        state.orders = action.payload.orders;
        state.page = action.payload.page;
        state.count = action.payload.count;
      })
      .addCase(getMerchantOrders.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default merchantOrdersSlice.reducer;
